import React from "react";
import { FileText } from "lucide-react";
import { DOWNLOAD_TYPES } from "../../config/downloads";

/**
 * Professional placeholders for unavailable product downloads.
 */
export default function ProductDownloads({ downloads }) {
  const items =
    downloads && downloads.length
      ? downloads
      : DOWNLOAD_TYPES.map((d) => ({
          id: d.id,
          name: d.name,
          status: "Coming Soon",
          available: false,
        }));

  return (
    <div data-testid="product-downloads">
      <div className="font-mono-2 text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-4">
        § Downloads
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {items.map((item) => (
          <div
            key={item.id || item.name}
            className="flex items-start gap-3 border border-border bg-secondary/30 p-4"
            data-testid={`download-${item.id || item.name}`}
          >
            <FileText
              size={18}
              strokeWidth={1.3}
              className="text-[color:var(--steel)] mt-0.5 shrink-0"
            />
            <div className="min-w-0">
              <div className="text-sm text-foreground">{item.name}</div>
              <div
                className="mt-1 font-mono-2 text-[10px] tracking-[0.2em] uppercase"
                style={{ color: "var(--gold)" }}
              >
                {item.status || "Coming Soon"}
              </div>
              {item.description && (
                <p className="mt-2 text-xs text-steel-text leading-relaxed">
                  {item.description}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
